import { render, staticRenderFns } from "./Shares.vue?vue&type=template&id=72909bfc&scoped=true&"
import script from "./Shares.vue?vue&type=script&lang=js&"
export * from "./Shares.vue?vue&type=script&lang=js&"
import style0 from "./Shares.vue?vue&type=style&index=0&id=72909bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72909bfc",
  null
  
)

export default component.exports